<script setup lang="ts">
    const modalController = useModal();
    const { t } = useI18n();

    const { auth } = useLoginState();
    const userName = computed(() => {
        return auth.value?.address?.firstName || '';
    });

    onMounted(() => {
        modalController.open();
    });

    function handleNoShow() {
        localStorage.setItem(NO_SHOW_KEY, '0');
        modalController.close();
    }

    const closeButtonRef = ref();

    watch(
        () => modalController.isOpen.value,
        async (open) => {
            if (open) {
                await nextTick();
                closeButtonRef.value?.focus();
            }
        }
    );
</script>

<template>
    <SharedModal
        :controller="modalController"
        class="modal-wrapper"
    >
        <SharedCloseButton
            ref="closeButtonRef"
            :label="t('general.close')"
            @click="modalController.close"
        />
        <div class="pta-post-login-modal">
            <div class="text">
                <h2>
                    {{
                        userName
                            ? t('ptaPostloginModal.salutation.personal', { username: userName })
                            : t('ptaPostloginModal.salutation.generic')
                    }}
                </h2>
                <p>{{ t('ptaPostloginModal.welcomeText') }}</p>

                <h3>{{ t('ptaPostloginModal.advantagesHeader') }}</h3>
                <ul>
                    <li>
                        <strong>{{ t('ptaPostloginModal.advantage1Title') }}</strong>
                        {{ t('ptaPostloginModal.advantage1Description') }}
                    </li>
                    <li>
                        <strong>{{ t('ptaPostloginModal.advantage2Title') }}</strong>
                        {{ t('ptaPostloginModal.advantage2Description') }}
                    </li>
                    <li>
                        <strong>{{ t('ptaPostloginModal.advantage3Title') }}</strong>
                        {{ t('ptaPostloginModal.advantage3Description') }}
                    </li>
                    <li>
                        <strong>{{ t('ptaPostloginModal.advantage4Title') }}</strong>
                        {{ t('ptaPostloginModal.advantage4Description') }}
                    </li>
                </ul>
            </div>
            <div class="button-wrapper">
                <PrimaryButton
                    button-href="https://login.medice.com/profile/consents/"
                    :open-new-tab="true"
                    :button-text="t('ptaPostloginModal.ctaText')"
                    :retain-size="true"
                    size="medium"
                />
                <PrimaryButton
                    :button-text="t('ptaPostloginModal.dontShow')"
                    :retain-size="true"
                    variant="secondary"
                    size="medium"
                    @click.prevent="handleNoShow()"
                />
            </div>
        </div>
    </SharedModal>
</template>

<style scoped lang="scss">
    @import '@/assets/scss/pta-family/postlogin-modal.scss';
    @import '~/assets/scss/text/text.scss';
</style>
